// extracted by mini-css-extract-plugin
export var card = "_mo-1";
export var summary = "_mo-0";
export var unreadDot = "_mo-2";